import React from 'react';
import moment from 'moment';
import { MarkupHelpers, dateHelpers } from '../../../../helpers';
import PropTypes from 'prop-types';
import publishers from './helpers/publishers';
import NewsCard from '../../../dashboardNew/components/cards/NewsCard';


export default function RSSFeedItem(props) {

    const {
        link,
        title,
        pubDate,
        content
    } = props.rssFeed;

    const publisher = publishers( props.rssFeed.publisher );
 
    const publisherIcon = publisher.icon
    const publisherAlt = publisher.name
    const newsLink = link
    const newsTitle = MarkupHelpers.escapeHtmlHelper(title)
    const newsDate = dateHelpers.dateConverter( pubDate, 'llll' )


    return (
        <NewsCard title={newsTitle} description={content} date={newsDate} link={newsLink} publisherIcon={publisherIcon} publisherAlt={publisherAlt}/>
    )
}

RSSFeedItem.propTypes = {
    rssFeed: PropTypes.object
};



// WEBPACK FOOTER //
// src/client/components/site/features/homepage/RSSFeedItem.js